import React from 'react';
import { Grid } from '@material-ui/core';
import { ViewStreamRounded, ViewModuleRounded } from '@material-ui/icons';
import { useTranslation } from 'react-i18next';

function ViewMode({ handleChange, isListView }) {
  const { t } = useTranslation();
  return (
    <Grid alignItems="center" justify="space-between" container>
      {t('settings-view-mode')}
      <Grid item justify="flex-end" alignItems="center">
        <ViewStreamRounded
          onClick={() => handleChange(true)}
          fontSize="large"
          color={isListView ? 'error' : 'disabled'}
        />
        <ViewModuleRounded
          onClick={() => handleChange(false)}
          fontSize="large"
          color={!isListView ? 'error' : 'disabled'}
        />
      </Grid>
    </Grid>
  );
}

export default ViewMode;
